import { render } from "./AdminEvents.vue?vue&type=template&id=07dd392b"
import script from "./AdminEvents.vue?vue&type=script&lang=js"
export * from "./AdminEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__